<template>
  <div>
    <Tabs :value="mIdx">
      <TabList>
        <Tab value=0>{{ $t('menu.order') }}</Tab>
        <Tab value=1>{{ $t('menu.cost') }}</Tab>
        <Tab value=2>{{ $t('menu.delivery') }}</Tab>
        <Tab value=3>{{ $t('menu.issue') }}</Tab>
        <Tab value=5 @click="click({type:'faq'})">{{ $t('menu.tip') }}</Tab>
        <Tab value=4>{{ $t('menu.etc') }}</Tab>
      </TabList>
      <TabPanels class="card main">
        <TabPanel value=0>
          <Accordion :value="idx">
            <AccordionPanel value="0" >
              <AccordionHeader >{{ $t('menu.requestBuy') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=0 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="1">
              <AccordionHeader class="datatable-background">{{$t('menu.requestDelivery')}}</AccordionHeader>
              <AccordionContent>
                <faqc idx=1 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="2">
            <AccordionHeader>{{$t('menu.requestPayment')}}</AccordionHeader>
              <AccordionContent>
                <faqc idx=2 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="3">
              <AccordionHeader class="datatable-background">{{ $t('menu.requiredInfo') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=3 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="4">
              <AccordionHeader>{{$t('menu.coo')}}(FTA)</AccordionHeader>
              <AccordionContent>
                <faqc idx=4 />
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </TabPanel>
        <TabPanel value=1>
          <Accordion :value="idx">
            <AccordionPanel value="5">
              <AccordionHeader>{{ $t('menu.estimatedQuote') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=5 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="6">
              <AccordionHeader class="datatable-background">{{ $t('menu.tax') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=6 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="7">
              <AccordionHeader>{{ $t('common.fee') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=7 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="8">
              <AccordionHeader class="datatable-background">{{ $t('menu.extraFee') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=8 />
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </TabPanel>
        <TabPanel value=2>
          <Accordion :value="idx">
            <AccordionPanel value="9">
              <AccordionHeader>{{ $t('menu.dPrice') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=9 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="10">
              <AccordionHeader class="datatable-background">{{ $t('menu.deliveryTime') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=10 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="11">
              <AccordionHeader>{{ $t('menu.carrier') }}</AccordionHeader>
                <AccordionContent>
                  <faqc idx=11 />
                </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="12">
              <AccordionHeader class="datatable-background">{{ $t('menu.progressStatus') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=12 />
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </TabPanel>
        <TabPanel value=3>
          <Accordion :value="idx">
            <AccordionPanel value="13">
              <AccordionHeader>{{ $t('menu.fraud') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=13 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="14">
              <AccordionHeader class="datatable-background">{{$t('menu.exchange')}}/{{$t('menu.refund')}}/{{ $t('menu.cancel') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=14 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="15">
              <AccordionHeader>{{ $t('common.customs') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=15 />
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </TabPanel>
        <TabPanel value="4">
          <Accordion :value="idx">
            <AccordionPanel value="16">
              <AccordionHeader>iPhone</AccordionHeader>
              <AccordionContent>
                <faqc idx=16 />
              </AccordionContent>
            </AccordionPanel>
            <AccordionPanel value="26">
              <AccordionHeader>{{ $t('menu.qna') }}</AccordionHeader>
              <AccordionContent>
                <faqc idx=26 />
              </AccordionContent>
            </AccordionPanel>
          </Accordion>
        </TabPanel>
        <TabPanel value="5" >
          <read page='faq'/>
        </TabPanel>
      </TabPanels>
    </Tabs>
  </div>
</template>

<script>
import faqc from '../content/faq_content.vue'
import read from '@/Read.vue'

export default {
  mounted() {
    if(!(this.$route.query.idx == undefined || this.$route.query.idx === null || this.$route.query.idx === '')) {
      this.idx = this.$route.query.idx
      const tmpIdx = Number(this.idx)
      if(tmpIdx <= 4) this.mIdx = '0'
      else if(tmpIdx <= 8) this.mIdx = '1'
      else if(tmpIdx <= 12) this.mIdx = '2'
      else if(tmpIdx <= 15) this.mIdx = '3'
      else this.mIdx = '4'
    }
  },  
  components: {
    faqc, read
  },
  data() {
    return {
      idx:'-1',
      mIdx : '0',
    }
  },
  methods: {
    click(param) {
      const type = param.type
      if(type === 'faq') {
        this.emitter.emit('contentsTab')
      }
    }
  }
  
}

</script>
<style scoped>
.datatable-background {
  background-color:#f9f9f9;
}
</style>